import messages from '../../../../locale/messages';
import { inputTextLimit, inputDescLimit, containsMalicious } from '../../../../helpers/textRestriction';

const validate = values => {

  const errors = {}

  if (!values.userName) {
    errors.userName = messages.required;
  } else if (values.userName.trim() == "") {
    errors.userName = messages.required;
  } else if (values?.userName?.length > inputTextLimit) {
    errors.userName = messages.inputFieldRestriction;
  } else if (containsMalicious(values.userName)) {
    errors.userName = messages.invalidInput;;
  }

  if (!values.reviewContent) {
    errors.reviewContent = messages.required;
  } else if (values.reviewContent.trim() == "") {
    errors.reviewContent = messages.required;
  } else if (values?.reviewContent?.length > inputDescLimit) {
    errors.reviewContent = messages.descriptionFieldRestriction;
  } else if (containsMalicious(values.reviewContent)) {
    errors.reviewContent = messages.invalidInput;;
  }

  return errors
}

export default validate;